import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    ids: { type: Array, default: [] }
  }

  connect() {
    this.processIcon()
  }

  processIcon() {
    if (this.idsValue.length == 0) { return }
    if (this.currentUserId == 0) { this.disableFavButton(); return }

    if (this.idsValue.includes(this.currentUserId)) {
      this.element.classList.remove("opacity-25")
    }
  }

  disableFavButton() {
    this.favButton.disabled = true
  }

  get favButton() {
    return this.element.querySelector("button")
  }

  get currentUserId() {
    return Number(document.body.dataset.currentUserId)
  }
}
